import React from 'react';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { Flex, Body, Box } from '@edreamsodigeo/prisma-design-system';
import CarrierLogo from './CarrierLogo';

interface CarrierComponentProps {
  carriers: {
    id: string;
    name: string;
  }[];
  displayText: string;
  imageSize: string;
}

const CarrierComponent: React.FC<CarrierComponentProps> = ({
  carriers,
  displayText,
}) => {
  return (
    <Flex alignItems="center">
      <Flex as="span" alignItems="center">
        {carriers.map((carrier, index) => (
          <Box sx={{ marginLeft: index > 0 ? '-10px' : null }} key={carrier.id}>
            <CarrierLogo id={carrier.id} name={carrier.name} />
          </Box>
        ))}
      </Flex>
      <Body type="xSmall" color="neutral.70">
        {displayText}
      </Body>
    </Flex>
  );
};

interface CarrierProps {
  carriers: {
    id: string;
    name: string;
  }[];
}

const Carrier: React.FC<CarrierProps> = ({ carriers }) => {
  const { t } = useTranslation();
  const isMulti = carriers.length > 1;
  const displayText = isMulti
    ? t('results.multiple.airlines')
    : carriers[0].name;

  return (
    <CarrierComponent
      carriers={carriers}
      displayText={displayText}
      imageSize="small"
    />
  );
};

export default Carrier;
